import MUIDataTable from 'mui-datatables';
import React from 'react'
import { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { Link } from 'react-router-dom';
import Toggle from 'react-toggle';
import { getFuelTypeList , updateFuelType,DeleteCarFuelType } from '../../../actions/homeAction';

const CarModel = () => {

	const dispatch = useDispatch()
 
	useEffect(() => {
		dispatch(getFuelTypeList())
	},[])

	const handleStatusChange = (Id,active)=>{
		var data ={
			fuelTypeId: Id,
			active : !active
		}
		dispatch(updateFuelType(data))
	}

	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarFuelType(ID))
		}
	}

	const fuelTypeList = useSelector(state => state.home.fuelTypeList)?.response

	console.log("fuelTypeList", fuelTypeList);
  const carModelList = []
  let columns = [];

		columns = [
			{
				name: 'fuelType',
				label: 'Fuel Type Name',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'fuelTypeAr',
				label: 'Fuel Type Name Ar',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'priority',
				label: 'Priority',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'active',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (active, tableMeta) => {
						var Id = tableMeta.rowData[2];
						return (
							<Toggle
								id={'status_' + Id}
								defaultChecked={active}
								value={active}
								onChange={()=>handleStatusChange(Id, active)}
							/>
						);
					},
				},
			},
			{
				name: 'fuelTypeId',
				label: 'Action',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (fuelTypeId) => {
						return (
							<div>
								<Link to={`/CarDetail/FuelType/Update/${fuelTypeId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
								<span className='delBTN' onClick={()=>HandleDelete(fuelTypeId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
							</div>
						);
					},
				},
			},

		];
    
		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					// noMatch: this.state.isSaving
					// 	? 'Loading data..!'
					// 	: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/CarDetail/FuelType/Add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Fuel Type
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{carModelList !== undefined ? (
												<MUIDataTable
													title={`Fuel Type`}
													className='table-responsive'
													data={fuelTypeList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default CarModel